import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import WhatsAppFab from "@/components/WhatsAppFab";
import Vision from "@/pages/Vision";
import Cockpit from "@/pages/Cockpit";
import Studio from "@/pages/Studio";
import Vault from "@/pages/Vault";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/contexts/I18nContext";

export default function App() {
  return (
    <I18nProvider>
      <div className="App">
        <BrowserRouter>
          <Navbar />
          <main className="dncm-shell">
            <Routes>
              <Route path="/" element={<Navigate to="/vision" replace />} />
              <Route path="/vision" element={<Vision />} />
              <Route path="/agents" element={<Navigate to="/vision#escouade" replace />} />
              <Route path="/studio" element={<Studio />} />
              <Route path="/vault" element={<Vault />} />
              <Route path="/cockpit" element={<Cockpit />} />
              <Route path="*" element={<Navigate to="/vision" replace />} />
            </Routes>
          </main>
          <WhatsAppFab />
          <Toaster theme="dark" />
        </BrowserRouter>
      </div>
    </I18nProvider>
  );
}
